// @ts-strict-ignore
import {RollupProjectDataset} from 'common/types/reports/datasets';

import {appApiUrl} from '../utils';
import {BaseClient} from '../utils/base-client';

class DatasetsClient extends BaseClient {
  buildEndpoint({projectId}) {
    return appApiUrl(`datasets/`, {projectId});
  }

  processResponse(response): RollupProjectDataset[] {
    const {results = null, error = null} = response;

    if (error) {
      throw new Error(`Datasets API error: ${error}`);
    }

    return results;
  }
}

export const datasetsClient = new DatasetsClient();
